import { createQueryKeys } from "@plerity/data-access";

/** Scoped query key factory for Social Media — ensures consistent cache invalidation. */
export const socialKeys = createQueryKeys("social");
